// app/sezioni/sezioni.js

(function () {
    'use strict';
    var controllerId = 'sezione';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', sezioneFn]);

    function sezioneFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = $translate.instant('Sezioni');
        vm.view = 'list';       //Opzione list or detail
        vm.sectionMenu = sectionMenu.setSection('Sezioni');                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;       
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Codice', 'Titolo'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Filtro
        vm.filter = {};
        vm.filter.ricerca = vm.fRicerca = '';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;        

        //Gestione sezioni        
        vm.add = addSezione;
        vm.edit = editSezione;
        vm.delete = deleteSezione;
        

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.sezioniId != null) {
                        getRecord($routeParams.sezioniId, 0);
                    }
                });
        }

        //****************************************************
        // METODI 
        //****************************************************

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.sezione_countAll(vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.sezione_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;               
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            return datacontext.sezione_get(id).then(function (data) {                
                vm.index = index;
                vm.record = data;                

                setView('detail');
            });
        } 

        function addSezione() {
            var modalSezione = {};
            modalSezione.Id = 0;
            
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/sezioni/modal/sezioneAddEdit.html?version=30',                                                                             
                controller: 'sezioneAddEdit',
                resolve: {                                      
                    sezione: function () {
                        return modalSezione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {  
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Centro di costo aggiunto con successo'));
                cerca();
            });
        }

        function editSezione(item, index) {
            var modalSezione = {};
            angular.copy(item, modalSezione);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/sezioni/modal/sezioneAddEdit.html?version=30',                                                                        
                controller: 'sezioneAddEdit',
                resolve: {                       
                    sezione: function () { 
                        return modalSezione;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) { 
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                logSuccess($translate.instant('Centro di costo modificato con successo'));
                cerca();
            });
        }

        function deleteSezione(item) {
            var msg = " " + $translate.instant('il centro di costo') + " "
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.sezione_delete(item.Id).then(function (data) {
                    if (data != 400 && data != 404) {
                        var index = vm.records.indexOf(item)
                        vm.records.splice(index, 1);
                        vm.countRecords--;
                        logSuccess($translate.instant('Centro di costo eliminato con successo'));
                    } else {
                        return logError($translate.instant('Impossibile eliminare il dato'));
                    }
                });
            });
        }
    }
})();
